// extracted by mini-css-extract-plugin
module.exports = {"employeeProfile":"EmployeeMember_employeeProfile__2iNFd","userIcon":"EmployeeMember_userIcon__1RiMX","editIcon":"EmployeeMember_editIcon__ACQSi"};